import { graphql, StaticQuery, StaticQueryDocument, useStaticQuery } from "gatsby"
import * as React from "react"
import { AfganistanFlag, ArgentinaFlag, AustraliaFlag, AzerbaijanFlag, BangladeshFlag, BrazilFlag, BulgariaFlag, ChinaFlag, CzechFlag, FijiFlag, FinlandFlag, FranceFlag, GeorgiaFlag, GermanyFlag, GreeceFlag, IndiaFlag, IndoneziaFlag, ItalyFlag, JamaicaFlag, KoreaFlag, LebanonFlag, MalaysiaFlag, MaltaFlag, NetherlandsFlag, NewZealandFlag, NigeriaFlag, PakistanFlag, PolandFlag, PortugalFlag, RomaniaFlag, RussiaFlag, SamoaFlag, ScotlandFlag, SerbiaFlag, SouthAfricaFlag, SpainFlag, SwedenFlag, ThailandFlag, TurkeyFlag, UKFlag, USAFlag, VietnamFlag, ZimbabweFlag } from "../atoms/Flags"

import * as styles from './styles.module.scss'

interface IProps {
  date: string
  time: string
  firstTeam: string
  firstTeamFlag: string
  secondTeam: string
  secondTeamFlag: string
  firstWinnerCoef: number
  secondWinnerCoef: number
  drawCoef?: number
  link: string
}

const Widget = ({
  date,
  time,
  firstTeam,
  firstTeamFlag,
  secondTeam,
  secondTeamFlag,
  firstWinnerCoef,
  secondWinnerCoef,
  drawCoef,
  link,
}: IProps) => {
  return (
    <a href={link} className={styles.widget}>
      <div className={styles.dates}>
        <div className={styles.date}>
          {formatDate(new Date(date))}
        </div>
        <div className={styles.time}>
          {time}
        </div>
      </div>
      <div className={styles.matchInfo}>
        <div className={styles.team}>
          <div className={styles.flag}>{getFlag(firstTeamFlag)}</div>
          <div className={styles.teamName}>{firstTeam}</div>
        </div>
        <div className={styles.vs}>vs</div>
        <div className={styles.team}>
          <div className={styles.flag}>{getFlag(secondTeamFlag)}</div>
          <div className={styles.teamName}>{secondTeam}</div>
        </div>
      </div>
      <div className={styles.bets}>
        <div className={styles.groupName}>Winner</div>
        <div className={styles.groupName}>Draw</div>
        <div className={styles.group}>
          <div className={styles.bet}>
            <div className={styles.header}>1</div>
            <div className={styles.coef}>{firstWinnerCoef}</div>
          </div>
          <div className={styles.bet}>
            <div className={styles.header}>2</div>
            <div className={styles.coef}>{secondWinnerCoef}</div>
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.bet}>
            <div className={styles.header}>-</div>
            <div className={styles.coef}>{drawCoef || "-"}</div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default Widget

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const formatDate = (someDate: Date) => {
  const date = someDate.getDate()
  const month = months[someDate.getMonth()]

  return `${month} ${date}, ${someDate.getFullYear()}`
}

const getFlag = (code: string) => {
  switch (code) {
    case 'afganistan':
      return <AfganistanFlag />
    case 'argentina':
      return <ArgentinaFlag />
    case 'australia':
      return <AustraliaFlag />
    case 'azerbaijan':
      return <AzerbaijanFlag />
    case 'bangladesh':
      return <BangladeshFlag />
    case 'brazil':
      return <BrazilFlag />
    case 'bulgaria':
      return <BulgariaFlag />
    case 'china':
      return <ChinaFlag />
    case 'czech':
      return <CzechFlag />
    case 'fiji':
      return <FijiFlag />
    case 'finland':
      return <FinlandFlag />
    case 'france':
      return <FranceFlag />
    case 'georgia':
      return <GeorgiaFlag />
    case 'germany':
      return <GermanyFlag />
    case 'greece':
      return <GreeceFlag />
    case 'india':
      return <IndiaFlag />
    case 'indonezia':
      return <IndoneziaFlag />
    case 'italy':
      return <ItalyFlag /> 
    case 'jamaica':
      return <JamaicaFlag /> 
    case 'korea':
      return <KoreaFlag />
    case 'lebanon':
      return <LebanonFlag /> 
    case 'malaysia':
      return <MalaysiaFlag />
    case 'malta':
      return <MaltaFlag />
    case 'netherlands':
      return <NetherlandsFlag />
    case 'newzeland':
      return <NewZealandFlag />
    case 'nigeria':
      return <NigeriaFlag />
    case 'pakistan':
      return <PakistanFlag />
    case 'poland':
      return <PolandFlag />
    case 'portugal':
      return <PortugalFlag />
    case 'romania':
      return <RomaniaFlag />
    case 'russia':
      return <RussiaFlag />
    case 'samoa':
      return <SamoaFlag />
    case 'scotland':
      return <ScotlandFlag />
    case 'serbia':
      return <SerbiaFlag />
    case 'southafrica':
      return <SouthAfricaFlag />
    case 'spain':
      return <SpainFlag />
    case 'sweden':
      return <SwedenFlag />
    case 'thailand':
      return <ThailandFlag />
    case 'turkey':
      return <TurkeyFlag />
    case 'uk':
      return <UKFlag />
    case 'usa':
      return <USAFlag />
    case 'vietnam':
      return <VietnamFlag />
    case 'zimbabwe':
      return <ZimbabweFlag />
    default:
      null
  }
}